import { capitalize } from '@btime/helpers'

export const getFilteredPlaceLevelTypes = (levels, placeTypes, permissions) => {
  const groupedLevels = levels.reduce((acc, level) => {
    if (!level.enabled) return acc

    const groupName = placeTypes.find(type => type.key === level.type)?.name
    const type = level.type
    if (!groupName) return acc

    if (!acc[type]) {
      acc[type] = []
    }

    acc[type].push({
      id: level.id,
      name: level.name,
      type: level.type,
      group: groupName,
      hasPermission: permissions.find(permission => permission.name === `list${capitalize(level.type)}`)?.enabled
    })

    return acc
  }, {})

  return Object.values(groupedLevels)
    .reduce((acc, groupLevels) => {
      return [...acc, ...groupLevels.slice(0, -1)]
    }, [])
    .filter(level => level.hasPermission)
}

export const isArrayOfStrings = value => {
  return Array.isArray(value) && value.every(item => typeof item === 'string')
}

export const getUniqueValuesFromArrayOfObjects = (value = [], key) => {
  return [...new Set(value.map(item => item[key]))]
}

const processObjectArray = array => {
  if (!array?.length) return undefined

  return [...new Set(array.map(item => item?.id))]
}

const processTypesArray = array => {
  if (!array?.length) return undefined

  if (isArrayOfStrings(array)) return array

  return [...new Set(array.map(item => item?.type))]
}

const processValue = (value, key) => {
  if (key === 'types') return processTypesArray(value)

  return processObjectArray(value)
}

export const clearFilterParams = filterParams => {
  const cleanedParams = {}

  for (const [key, value] of Object.entries(filterParams)) {
    const processedValue = processValue(value, key)

    if (processedValue !== undefined) {
      cleanedParams[key] = processedValue
    }
  }

  return cleanedParams
}
